import React, { useState } from "react";
import { Input, Select, Button } from "antd"; // CHANGED: removed Drawer import - no longer used, everything is inline now
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import * as Styled from "./debriefingStyles";
import Sidemenu from "../../components/sidemenu";
import { message } from "antd";
import { functionService } from "../../lib/functions";

import { useLocation } from "react-router-dom";
import CandidatesTable from "../CandidatesTable";
import { useNavigate } from "react-router-dom";

const { TextArea } = Input;
const { Option } = Select;

const Debriefing = () => {
    const navigate = useNavigate();
    const location = useLocation();
    console.log("LOCATION OBJECT:", location);
    console.log("LOCATION STATE:", location.state);

    // console.log(location.state);
    const [formData, setFormData] = useState({
        candidateName: location.state?.candidateName || "",
        candidateEmail: location.state?.candidateEmail || "",
        interviewRound: location.state?.interviewRound || "",
        interviewQuestions: [""],
        additionalInfo: "",
    });

    // NEW: Debrief Status (Yes/No) - inline choice at top of the same page.
    // null = nothing selected yet | "yes" = show existing form | "no" = show reason field
    const [debriefStatus, setDebriefStatus] = useState(null);

    // NEW: NO Debrief Reason Flow - reason text, error, loading (no drawer state needed anymore)
    const [debriefNoReason, setDebriefNoReason] = useState("");
    const [noReasonError, setNoReasonError] = useState("");
    const [isSubmittingNoReason, setIsSubmittingNoReason] = useState(false);

    const handleSubmit = async () => {
        const isValid = validateForm();
        if (!isValid) return;
        try {
            const payload = {
                candidate_id: location.state?.candidateId,
                debrief_form: [
                    {
                        round_name: formData.interviewRound,
                        questions: formData.interviewQuestions,
                        additional_information:
                            formData.additionalInfo || "",
                    },
                ],
            };

            // console.log("PAYLOAD:", payload);

            const response = await functionService.post(
                "demand/save-debrief",
                payload
            );

            // console.log("API RESPONSE:", response);

            if (response?.status) {
                message.success("Debrief saved successfully");
                navigate("/interview-table");
            } else {
                const errorMessage =
                    response?.error?.response?.data?.meta?.message ||
                    "Failed to save debrief";

                if (errorMessage.toLowerCase().includes("already submitted")) {
                    setFieldErrors((prev) => ({
                        ...prev,
                        interviewRound: errorMessage,
                    }));

                    setValidFields((prev) => ({
                        ...prev,
                        interviewRound: false,
                    }));

                    return;
                }

                message.error(errorMessage);
            }
        } catch (error) {
            // console.error("SAVE DEBRIEF ERROR:", error);

            const errorMessage =
                error?.response?.data?.meta?.message ||
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong";

            if (
                errorMessage.toLowerCase().includes("already submitted") ||
                errorMessage.toLowerCase().includes("please complete round")
            ) {
                setFieldErrors((prev) => ({
                    ...prev,
                    interviewRound: errorMessage,
                }));

                setValidFields((prev) => ({
                    ...prev,
                    interviewRound: false,
                }));

                return;
            }
            // console.log("ERROR MESSAGE:", errorMessage);

            message.error(errorMessage);
        }
    };

    const [fieldErrors, setFieldErrors] = useState({});
    const [validFields, setValidFields] = useState({});

    const FieldError = ({ field }) => {
        if (!fieldErrors[field]) return null;
        return <Styled.ErrorMessage>{fieldErrors[field]}</Styled.ErrorMessage>;
    };

    const validateForm = () => {
        const errs = {};
        const valid = {};

        if (!formData.candidateName?.trim()) {
            errs.candidateName = "Candidate Name is required";
        } else {
            valid.candidateName = true;
        }

        if (!formData.candidateEmail?.trim()) {
            errs.candidateEmail = "Candidate Email ID is required";
        } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                formData.candidateEmail
            )
        ) {
            errs.candidateEmail = "Please enter a valid Email ID";
        } else {
            valid.candidateEmail = true;
        }

        if (!formData.interviewRound) {
            errs.interviewRound = "Please select an Interview Round";
        }
        else {
            valid.interviewRound = true;
        }


        const firstQuestionValid =
            formData.interviewQuestions[0]?.trim();

        if (!firstQuestionValid) {
            errs.interviewQuestions =
                "Question 1 is required";
        } else {
            valid.interviewQuestions = true;
        }

        setFieldErrors(errs);
        setValidFields(valid);

        return Object.keys(errs).length === 0;
    };

    const handleChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));

        if (fieldErrors[field]) {
            setFieldErrors((prev) => ({
                ...prev,
                [field]: "",
            }));
        }
    };

    const handleQuestionChange = (index, value) => {
        const updatedQuestions = [...formData.interviewQuestions];
        updatedQuestions[index] = value;
        setFormData((prev) => ({
            ...prev,
            interviewQuestions: updatedQuestions,
        }));

        if (fieldErrors.interviewQuestions) {
            setFieldErrors((prev) => ({
                ...prev,
                interviewQuestions: "",
            }));
        }
    };

    const addQuestion = () => {
        setFormData((prev) => ({
            ...prev,
            interviewQuestions: [...prev.interviewQuestions, ""],
        }));
    };

    const removeQuestion = (index) => {
        if (formData.interviewQuestions.length > 1) {
            const updatedQuestions = formData.interviewQuestions.filter(
                (_, i) => i !== index
            );
            setFormData((prev) => ({
                ...prev,
                interviewQuestions: updatedQuestions,
            }));
        }
    };

    // const handleSubmit = () => {
    //     const isValid = validateForm();
    //     if (!isValid) return;

    //     console.log("Debriefing Data:", formData);
    //     // API Call Here
    // };

    // NEW: Debrief Status toggle handler - switches which section is shown
    // below, without resetting formData or the entered NO reason, so
    // switching back and forth doesn't lose anything already typed.
    const handleDebriefStatusChange = (status) => {
        // NEW: don't allow switching status mid-submission
        if (isSubmittingNoReason) return;
        setDebriefStatus(status);
        setNoReasonError("");
    };

    // NEW: NO Debrief Reason Flow - submit handler
    // Calls the already-implemented functionService.saveDebriefNoReason(payload)
    // and the already-implemented backend - nothing on the backend/API side
    // is touched here.
    const handleSubmitNoReason = async () => {
        // NEW: prevent duplicate submission while a request is already in flight
        if (isSubmittingNoReason) return;

        if (!debriefNoReason.trim()) {
            setNoReasonError("Please enter a reason before submitting");
            return;
        }
        setNoReasonError("");
        setIsSubmittingNoReason(true);

        try {
            const payload = {
                candidate_id: location.state?.candidateId,
                demand_id: location.state?.demandId,
                round_name: formData.interviewRound,
                debrief_no_reason: [
                    {
                        round_name: formData.interviewRound,
                        reason: debriefNoReason,
                        submitted_at: new Date().toISOString(),
                    },
                ],
            };

            const response = await functionService.saveDebriefNoReason(payload);

            if (response?.status) {
                message.success("Reason saved successfully");
                setDebriefNoReason("");
                setNoReasonError("");
                navigate("/interview-table");
            } else {
                // NEW: on failure, stay on the page and keep the entered reason
                const errorMessage =
                    response?.error?.response?.data?.meta?.message ||
                    "Failed to save reason";
                message.error(errorMessage);
            }
        } catch (error) {
            // NEW: same failure handling for thrown errors - reason text is preserved
            const errorMessage =
                error?.response?.data?.meta?.message ||
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong";
            message.error(errorMessage);
        } finally {
            setIsSubmittingNoReason(false);
        }
    };

    return (
        <Styled.PageWrapper>
            <Sidemenu />
            <Styled.ContentArea>
                <Styled.Container>
                    <Styled.FormCard>
                        <Styled.Title>Interview Debriefing</Styled.Title>
                        <Styled.Description >
                            Please provide interview feedback and candidate
                            assessment details.
                        </Styled.Description>

                        {/* NEW: Debrief Status - Yes/No choice, inline on this same page */}
                        <Styled.FieldWrapper>
                            <Styled.Label>
                                Debrief Status <span>*</span>
                            </Styled.Label>
                            <Styled.DecisionButtonWrapper style={{ justifyContent: "flex-start", marginTop: 0 }}>
                                <Button
                                    type={debriefStatus === "yes" ? "primary" : "default"}
                                    size="large"
                                    disabled={isSubmittingNoReason}
                                    onClick={() => handleDebriefStatusChange("yes")}
                                >
                                    Yes
                                </Button>
                                <Button
                                    type={debriefStatus === "no" ? "primary" : "default"}
                                    size="large"
                                    disabled={isSubmittingNoReason}
                                    onClick={() => handleDebriefStatusChange("no")}
                                >
                                    No
                                </Button>
                            </Styled.DecisionButtonWrapper>
                        </Styled.FieldWrapper>

                        {/* Candidate Name */}
                        <Styled.FieldWrapper>
                            <Styled.Label>
                                Candidate Name <span>*</span>
                            </Styled.Label>
                            <Styled.InputWrapper
                                isValid={validFields.candidateName}
                                isError={!!fieldErrors.candidateName}
                            >
                                <Input
                                    placeholder="First and last name"
                                    value={formData.candidateName}
                                    disabled
                                    onChange={(e) =>
                                        handleChange(
                                            "candidateName",
                                            e.target.value
                                        )
                                    }
                                />
                            </Styled.InputWrapper>
                            <FieldError field="candidateName" />
                        </Styled.FieldWrapper>

                        {/* Candidate Email */}
                        <Styled.FormRow>

                            <Styled.HalfField>
                                <Styled.FieldWrapper>
                                    <Styled.Label>
                                        Candidate E-mail ID <span>*</span>
                                    </Styled.Label>

                                    <Styled.InputWrapper
                                        isValid={validFields.candidateEmail}
                                        isError={!!fieldErrors.candidateEmail}
                                    >
                                        <Input
                                            placeholder="Enter email address"
                                            value={formData.candidateEmail}
                                            disabled
                                            onChange={(e) =>
                                                handleChange("candidateEmail", e.target.value)
                                            }
                                        />
                                    </Styled.InputWrapper>

                                    <FieldError field="candidateEmail" />
                                </Styled.FieldWrapper>
                            </Styled.HalfField>

                            <Styled.HalfField>
                                <Styled.FieldWrapper>
                                    <Styled.Label>
                                        Interview Round <span>*</span>
                                    </Styled.Label>

                                    <Styled.InputWrapper
                                        isValid={validFields.interviewRound}
                                        isError={!!fieldErrors.interviewRound}
                                    >
                                        <Select
                                            style={{ width: "100%" }}
                                            size="large"
                                            value={formData.interviewRound || undefined}
                                            disabled
                                        >
                                            <Option value={formData.interviewRound}>
                                                {formData.interviewRound}
                                            </Option>
                                        </Select>
                                    </Styled.InputWrapper>

                                    <FieldError field="interviewRound" />
                                </Styled.FieldWrapper>
                            </Styled.HalfField>

                        </Styled.FormRow>

                        {debriefStatus === "yes" && (
                            // EXISTING: Debrief Form fields - completely unchanged, just now
                            // conditionally shown inline instead of after a separate screen
                            <>
                                {/* Interview Questions - Dynamic */}
                                <Styled.QuestionsSection>
                                    <Styled.SectionHeader>
                                        <Styled.Label style={{ marginBottom: 0 }}>
                                            Interview Questions <span>*</span>
                                        </Styled.Label>
                                    </Styled.SectionHeader>

                                    <Styled.QuestionsContainer>
                                        {formData.interviewQuestions.map(
                                            (question, index) => (
                                                <Styled.QuestionBlock
                                                    key={index}
                                                    isError={
                                                        !!fieldErrors.interviewQuestions
                                                    }
                                                >
                                                    <Styled.QuestionHeader>
                                                        <Styled.QuestionLabel>
                                                            Question {index + 1}
                                                        </Styled.QuestionLabel>
                                                        {formData.interviewQuestions
                                                            .length > 1 && (
                                                                <Styled.RemoveQuestionBtn
                                                                    onClick={() =>
                                                                        removeQuestion(
                                                                            index
                                                                        )
                                                                    }
                                                                    title="Remove this question"
                                                                >
                                                                    <MinusOutlined />
                                                                </Styled.RemoveQuestionBtn>
                                                            )}
                                                    </Styled.QuestionHeader>

                                                    <Styled.QuestionInputWrapper
                                                        isError={
                                                            !!fieldErrors.interviewQuestions
                                                        }
                                                    >
                                                        <TextArea
                                                            rows={6}
                                                            placeholder="Enter interview question and response"
                                                            value={question}
                                                            onChange={(e) =>
                                                                handleQuestionChange(
                                                                    index,
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                    </Styled.QuestionInputWrapper>
                                                </Styled.QuestionBlock>
                                            )
                                        )}
                                    </Styled.QuestionsContainer>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            marginTop: "12px",
                                        }}
                                    >
                                        <Styled.AddQuestionBtn
                                            onClick={addQuestion}
                                            title="Add another question"
                                        >
                                            <PlusOutlined /> Add Question
                                        </Styled.AddQuestionBtn>
                                    </div>
                                    <FieldError field="interviewQuestions" />
                                </Styled.QuestionsSection>

                                {/* Additional Information */}
                                <Styled.FieldWrapper>
                                    <Styled.Label>Additional Information</Styled.Label>
                                    <Styled.InputWrapper>
                                        <TextArea
                                            rows={4}
                                            placeholder="Add any additional comments or observations"
                                            value={formData.additionalInfo}
                                            onChange={(e) =>
                                                handleChange(
                                                    "additionalInfo",
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </Styled.InputWrapper>
                                </Styled.FieldWrapper>

                                {/* Error Summary */}
                                {Object.keys(fieldErrors).length > 0 && (
                                    <Styled.ErrorSummary>
                                        <p>
                                            Please fix the following before submitting:
                                        </p>
                                        <ul>
                                            {Object.values(fieldErrors)
                                                .filter(Boolean)
                                                .map((msg, i) => (
                                                    <li key={i}>{msg}</li>
                                                ))}
                                        </ul>
                                    </Styled.ErrorSummary>
                                )}

                                <Styled.ButtonWrapper>
                                    <Button
                                        type="primary"
                                        size="large"
                                        onClick={handleSubmit}
                                    >
                                        Submit Debriefing
                                    </Button>
                                </Styled.ButtonWrapper>
                            </>
                        )}

                        {debriefStatus === "no" && (
                            // NEW: NO Debrief Reason Flow - inline reason field, no drawer/modal
                            <>
                                <Styled.FieldWrapper>
                                    <Styled.Label>
                                        Reason for No Debrief <span>*</span>
                                    </Styled.Label>
                                    <Styled.InputWrapper isError={!!noReasonError}>
                                        <TextArea
                                            rows={6}
                                            placeholder="Enter reason here..."
                                            value={debriefNoReason}
                                            onChange={(e) => {
                                                setDebriefNoReason(e.target.value);
                                                if (noReasonError) setNoReasonError("");
                                            }}
                                        />
                                    </Styled.InputWrapper>
                                    {noReasonError && (
                                        <Styled.ErrorMessage>{noReasonError}</Styled.ErrorMessage>
                                    )}
                                </Styled.FieldWrapper>

                                <Styled.ButtonWrapper>
                                    <Button
                                        type="primary"
                                        size="large"
                                        loading={isSubmittingNoReason}
                                        onClick={handleSubmitNoReason}
                                    >
                                        Submit No Debrief
                                    </Button>
                                </Styled.ButtonWrapper>
                            </>
                        )}
                    </Styled.FormCard>
                </Styled.Container>
            </Styled.ContentArea>
        </Styled.PageWrapper>
    );
};

export default Debriefing;